import { useContext } from 'react';

import { ConstructorContext } from 'search/providers/ConstructorProvider';

export const useConstructorClient = () => useContext(ConstructorContext);
